import React from "react";
import { cn } from "@/utils/utils";

interface Props {
  children: React.ReactNode;
  /** Width handling, which is the caller's to decide: a field has a design
   *  maximum, a record column has whatever the column gives it. */
  className?: string;
}

// Grouped file rows draw their own border and fill; this stack only clips them
// into a single rounded card so adjacent hairlines collapse into one, and caps
// the height so a large attachment set scrolls rather than pushing everything
// below it off screen.
export const FileItemStack: React.FC<Props> = ({ children, className }) => (
  <div
    className={cn(
      "flex flex-col max-h-[400px] rounded-lg overflow-y-auto [&>*:not(:first-child)]:-mt-[0.5px]",
      className
    )}
  >
    {children}
  </div>
);
